<template>
  <div class="body-container order-page" :class="{'big-list':!(activeIndex==0||activeIndex==2)}">
    <div class="head-box">
      <van-tabs v-model="activeIndex" @change='tabClick' class="list-tabs small">
        <van-tab title="全部" name="0"></van-tab>
        <van-tab title="核保中" name="1"></van-tab>
        <van-tab title="核保成功" name="2"></van-tab>
        <van-tab title="核保失败" name="3"></van-tab>
      </van-tabs>
    </div>
    <orderList ref="list" :pageFlag="rhPage" @setListParams="setListParams" @listCallback="listCallback"></orderList>
  </div>
</template>

<script>
import orderList from "@/components/order/list";
import {pageTools,common} from "@/api/mixins";
export default {
  mixins:[pageTools,common],
  components:{orderList},
  data() {
    return {
      rhPage:'rhPage',
      listLoading:false,
      showSelectPanel:false,//账户类型弹窗
      type:"1",
      typeName:"全部账户",
      name: "",//投/被人姓名
      startTime:"",
      endTime:"",
      incomes:"",//服务费
      totalFee:"",//保费
      ordersNum:"",//订单数
      activeIndex: 0,
      list:[],
    };
  },
  mounted() {
    if(!this.checkLogin()){
      return;
    }
    // if(sessionStorage.rhOrderTab) {
    //   this.activeIndex = sessionStorage.rhOrderTab*1;
    // }
    // 查询订单列表
    this.$weixin.hideMenu();
    // 初始化列表
    this.$refs.list.init();
  },
  methods: {
    listCallback(res){
      this.listLoading = false;
      this.list = res.data;
    },
    //设置产品参数
    setListParams(params){
      this.listLoading = true;
      this.$refs.list.listUrl = "/api/getMyOrder";
      params.auditOrder = true
      if(this.activeIndex==1){//核保中
        // 凤栖参数
        params.orderStatus = '7';
        // 保险中介云参数
        params.status = '1'
        params.checkInsuranceStatus = '2'
      }else if(this.activeIndex==2){//核保成功
        // 凤栖参数
        params.orderStatus = '1,2,3,5,9,-9';
        // 保险中介云参数
        params.status = '1';
        params.checkInsuranceStatus = '1'
      }else if(this.activeIndex==3){//核保失败
        // 凤栖参数
        params.orderStatus = '4,6';
        // 保险中介云参数
        params.status = '1';
        params.checkInsuranceStatus = '3'
      }
      return params
    },
    // 列表跳转
    goPage(url, params, e) {
      if(e.target.className.indexOf("copy") != -1){
        return;
      }
      this.$router.push({
        path: url,
        query: params
      });
    },
    tabClick(){
      // console.log(this.activeIndex)
      // sessionStorage.rhOrderTab = this.activeIndex;
      this.list = [];
      this.$refs.list.searchAjax();
    },
  },

};
</script>

<style lang="scss" scoped>
@import "./list";
</style>
